module.exports = __webpack_public_path__ + "media/images/bg-cardboard-5d733d6264023a4bb8514d4a0734c89d.jpg";